import { Component, inject } from '@angular/core';
import { SpacingTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpacingTypeCreateDto,
  SpacingTypeDto,
  SpacingTypeExcelDownloadDto,
  SpacingTypeUpdateDto,
} from '../proxy/planning/dtos/spacing-type';
import { SPACINGTYPE_CONFIG, SPACINGTYPE_FIELDS } from './spacing-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-spacing-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpacingTypeService, ConfirmationService],
  templateUrl: './spacing-type.html',
  styleUrl: './spacing-type.scss',
})
export class SpacingType extends BaseCrudComponent<
  SpacingTypeDto,
  SpacingTypeCreateDto,
  SpacingTypeUpdateDto,
  SpacingTypeExcelDownloadDto
> {
  service = inject(SpacingTypeService);
  config = SPACINGTYPE_CONFIG;
  fields = SPACINGTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpacingTypeDto): SpacingTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpacingType';
  }
}
